import { ImportOutlined } from "@ant-design/icons"
import { Upload, Button } from "antd"
import React, { useEffect, useRef, useState } from "react"

const analysisTypes = [ "pdf", "description", "url" ]

const isValidJSON = ( json ) => {
	if ( typeof json === "object" && json !== null ) {
		const idSet = new Set()
		if ( Array.isArray( json.skills ) && json.skills.length ) {
			return json.skills.every( skill => {
				if ( skill.skillType === "training" && typeof skill.trainingId === "number" && typeof skill.enabled === "boolean" ) {
					return true
				}
				if (
					typeof skill.id === "string"
					&& !idSet.has( skill.id )
					&& ( skill.skillType === "manual"
						|| ( analysisTypes.includes( skill.skillType )
							&& typeof skill.analysisSource === "string" ) )
				) {
					idSet.add( skill.id )
					if ( typeof skill.name === "string" && typeof skill.enabled === "boolean" ) {
						if ( Array.isArray( skill.skillsGroup ) ) {
							return skill.skillsGroup.every( group => typeof group === "number" )
						}
					}
				}
				return false
			} )
		}
	}
	return false
}

export const ImportButton = ( {
	showMessage,
	onImportSuccess,
} ) => {
	const [ importing, setImporting ] = useState( false )
	const importingRef = useRef( importing )

	useEffect( () => {
		importingRef.current = importing
	}, [ importing ] )

	const customRequest = async ( { file } ) => {
		showMessage( { type: "loading", content: "Importing Skills...", key: "updatable", duration: 5 } )
		if ( importingRef.current ) {
			return
		}
		setImporting( true )
		try {
			if ( importingRef.current ) {
				return
			}
			const text = await file.text()
			const json = JSON.parse( text )

			if (
				isValidJSON( json )
			) {
				onImportSuccess( json )
				showMessage( { type: "loading", content: "Importing Skills...", key: "updatable", duration: 0.2 } )
				showMessage( { type: "success", content: "Skills import done." } )
			} else {
				showMessage( { type: "loading", content: "Importing Skills...", key: "updatable", duration: 0.2 } )
				showMessage( { type: "error", content: "Invalid skills file format!" } )
			}
		} catch ( _err ) {
			showMessage( { type: "loading", content: "Importing Skills...", key: "updatable", duration: 0.2 } )
			showMessage( { type: "error", content: "Something went wrong!" } )
		} finally {
			setImporting( false )
		}
	}

	return (
		<Upload
			accept={ "application/json" }
			maxCount={ 1 }
			showUploadList={ false }
			customRequest={ customRequest }
		>
			<Button
				className={ "list-container-action-button list-container-import-action" }
				loading={ importing }
				disabled={ importing }
				icon={ <ImportOutlined className={ "icon-position-fix" } /> }
			>
				{ "Import Skills" }
			</Button>
		</Upload>
	)
}
